import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as NVBIcon } from './nvb.svg';

export const NVB = IconHOC(NVBIcon);
